import { typeDisscount } from '../constants/options.constant';

export const checkMax = (mechanic, props) => {
	if (mechanic === typeDisscount.permanent) {
		return props?.record?.unit_price;
	}
	if (mechanic === typeDisscount.percentage) {
		return 100;
	}
};
